import { createUserManager } from 'redux-oidc';
import { getUserManagerConfigs } from './lib';

// Built at import time from the copy of /api/config cached in localStorage, because store.js needs
// the instance before anything has been fetched. On a browser that has never loaded RunPlanner that
// cache is empty, so the manager comes up with no authority and every signinRedirect() throws
// "No authority or metadataUrl configured on settings" for the life of the page. Rare for an office
// user, routine for the two browsers the truck console depends on: a console's fresh Chromium
// profile, and a driver opening a pairing link on a phone that has never used the app.
const userManager = createUserManager(getUserManagerConfigs());

/**
 * Applies the identity settings from /api/config to the manager built above.
 *
 * oidc-client is designed for this: authority and client_id have one-time setters precisely for
 * config discovered at runtime, and metadataUrl is derived from authority on first use rather than at
 * construction. scope has no setter, so it goes through to the backing field.
 *
 * Each field is only filled if it is still empty — that is what keeps the one-time setters from
 * throwing on the common path, where localStorage already held a usable config and there is nothing
 * to do.
 */
export function configureUserManager(config) {
    const settings = config && userManager.settings;
    if (!settings) {
        return;
    }

    if (config.authority && !settings.authority) {
        settings.authority = config.authority;
    }

    if (config.clientId && !settings.client_id) {
        settings.client_id = config.clientId;
    }

    if (config.scope && !settings.scope) {
        settings._scope = config.scope;
    }
}

export default userManager;
